// i18n area 'auth' — locale ro-RO (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.ro-RO.meta.json.
import type { enUS } from './auth'

export const roRO: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Conectează-te la contul tău',
    username: 'Nume de utilizator',
    usernamePlaceholder: 'Introdu numele de utilizator',
    usernameHint: 'Folosește utilizator@domeniu pentru a te autentifica pe un realm de director',
    continue: 'Continuă',
    changeUser: 'Nu ești tu?',
    password: 'Parolă',
    forgotPassword: 'Ai uitat parola?',
    submit: 'Conectează-te',
    otp: 'Cod de unică folosință',
    otpSubtitle: 'Introdu codul din autentificatorul tău',
    otpHint: 'Șase cifre din aplicația de autentificare sau unul dintre codurile de recuperare',
    otpSubmit: 'Verifică',
    invalidCredentials: 'Nume de utilizator sau parolă nevalide',
    tooManyAttempts: 'Prea multe încercări — așteaptă un moment și reîncearcă',
    realmUnavailable: 'Realmul nu poate verifica credențialele în acest moment — store-ul clusterului nu este accesibil. Conectează-te ca utilizator local (break-glass).',
    genericError: 'Conectarea a eșuat — este accesibil backendul TVirt?'
  },
  user: {
    logout: 'Deconectează-te',
    password: {
      menu: 'Schimbă parola',
      title: 'Schimbă-ți parola',
      current: 'Parola actuală',
      new: 'Parolă nouă',
      confirm: 'Confirmă parola nouă',
      mismatch: 'Parolele nu coincid',
      error: 'Nu s-a putut schimba parola',
      forcedTitle: 'Schimbă parola pentru a continua',
      forcedHint: 'Această parolă a fost setată de un administrator și trebuie înlocuită înainte de a intra.',
      forcedSubmit: 'Schimbă și intră'
    },
    mfa: {
      title: 'Autentificare cu doi factori',
      subtitle: 'Un al doilea factor cerut la fiecare conectare',
      loadError: 'Nu s-a putut încărca starea celui de-al doilea factor',
      enrolled: 'Activ',
      notEnrolled: 'Inactiv',
      enrolledAt: 'Activat la',
      codesRemaining: 'Coduri de recuperare rămase',
      requiredHint:
        'Un administrator cere al doilea factor pe acest cont: configurează-l acum — până o faci, te poți conecta, dar nu mult altceva.',
      enroll: 'Configurează',
      enrollTitle: 'Configurează autentificarea cu doi factori',
      enrollHint: 'Scanează acest cod cu aplicația de autentificare, apoi tastează codul pe care îl arată pentru a confirma.',
      secretHint: 'Nu îl poți scana? Tastează acest secret în aplicație:',
      code: 'Codul din aplicație',
      confirm: 'Confirmă',
      startError: 'Nu s-a putut porni configurarea',
      confirmError: 'Nu s-a putut confirma configurarea',
      codesTitle: 'Codurile tale de recuperare',
      codesWarning:
        'Aceste coduri sunt afișate o singură dată. Salvează-le acum: fiecare te conectează atunci când autentificatorul nu este disponibil și fiecare este valabil o singură dată.',
      codesAck: 'Mi-am salvat codurile de recuperare',
      codesDone: 'Gata',
      copy: 'Copiază',
      copied: 'Copiat',
      download: 'Descarcă',
      regenerate: 'Coduri de recuperare noi',
      regenerateTitle: 'Regenerează codurile de recuperare',
      regenerateHint: 'Toate codurile emise până acum încetează să funcționeze în momentul în care este generat noul set.',
      regenerateConfirm: 'Regenerează',
      regenerateError: 'Nu s-au putut regenera codurile de recuperare',
      remove: 'Elimină',
      removeTitle: 'Elimină al doilea factor',
      removeConfirm: 'Elimină',
      removeHint: 'Contul revine doar la parolă. Poți configura din nou al doilea factor oricând.',
      removeRequiredHint:
        'Un administrator cere al doilea factor pe acest cont, așa că serverul va refuza eliminarea — cere-i mai întâi să ridice obligația.',
      removeError: 'Nu s-a putut elimina al doilea factor'
    },
    profile: {
      menu: 'Mergi la profilul meu',
      sessions: 'Sesiuni active',
      sessionsHint: 'Sesiunile tale deschise pe acest nod',
      sessionsEmpty: 'Nicio sesiune activă',
      sessionCreated: 'Conectat',
      sessionExpires: 'Expiră',
      revoke: 'Revocă sesiunea',
      revokeError: 'Nu s-a putut revoca sesiunea',
      loadError: 'Nu s-au putut încărca sesiunile'
    }
  }
}
